import React, { useContext, useState, useEffect } from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { renderFormField } from 'utils/forms'
import { selectData } from 'layouts/onboarding'
import ValuePoint from 'admin/components/ValuePoint'
import { Card, Grid, Typography, Box, Button, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const dollarCentsFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function Contributions401k({
  collapseSections,
  toggleCollapse,
  tspMaxContributionAmount,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {

  const [localForm, setLocalForm] = useState({
    balance: intakeState.traditionalBalance || 0,
    contribution: intakeState.traditionalContribution || '',
    contributionAmount: intakeState.traditionalContributionAmount || 0,
    rothBalance: intakeState.rothBalance || 0,
    rothContribution: intakeState.rothContribution || '',
    rothContributionAmount: intakeState.rothContributionAmount || 0,
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const showContribution = intakeState?.traditionalContribution || intakeState?.rothContribution

  const [percentDollarsQuestion, setPercentDollarsQuestion] = useState(true)
  const [percentDollarsQuestionRoth, setPercentDollarsQuestionRoth] =
    useState(true)

  const dollarsToPercent = (contributionAmount) => {
    return intakeState?.baseSalary
      ? (((contributionAmount / 80) * 2087) / intakeState?.baseSalary) * 100
      : 0
  }
  const percentToDollars = (contributionPercent) => {
    return intakeState?.baseSalary
      ? (intakeState?.baseSalary / 2087) * 80 * (contributionPercent / 100)
      : 0
  }

  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="401k"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('401kContributions')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                401k Contributions
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections['401kContributions']
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse
            in={collapseSections['401kContributions']}
            style={{ width: '100%' }}
          >
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} mt={2}>
                <Typography variant="h5">Traditional 401k Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'traditionalContribution',
                  label: 'Do you contribute to the Traditional 401k?',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.traditionalContribution,
                  onChange: updateIntakeStateAndSubmit((traditionalContribution) =>
                    updateIntakeStateAtKey({ traditionalContribution })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'traditionalBalance',
                  label: 'Current Traditional 401k balance',
                  placeholder: '$250,000.00',
                  inputType: 'currencyFloat',
                  value: localForm.traditionalBalance,
                  onChange: (e) => handleChange('traditionalBalance')(e),
                  onBlur: updateIntakeStateAndSubmit((traditionalBalance) =>
                    updateIntakeStateAtKey({ traditionalBalance })
                  ),
                })}
              </Grid>
              {showContribution && (
                <>
                  {percentDollarsQuestion ? (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'traditionalContribution',
                          label: 'What percentage do you contribute?',
                          placeholder: 'Ex. 5.0%',
                          inputType: 'percentage',
                          value: localForm.traditionalContributionAmount,
                          onChange: (e) => {
                            handleChange('traditionalContribution')(e)
                            handleChange('traditionalContributionAmount')(
                              percentToDollars(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (traditionalContribution) =>
                              updateIntakeStateAtKey({
                                traditionalContribution,
                                traditionalContributionAmount:
                                  percentToDollars(traditionalContribution),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestion(false)}
                        >
                          Use amount contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'traditionalContributionAmount',
                          label:
                            'What amount do you contribute per pay period?',
                          placeholder: '$135.00',
                          inputType: 'currencyFloat',
                          value: localForm.traditionalContributionAmount,
                          onChange: (e) => {
                            handleChange('traditionalContributionAmount')(e)
                            handleChange('traditionalContribution')(dollarsToPercent(e))
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (traditionalContributionAmount) =>
                              updateIntakeStateAtKey({
                                traditionalContributionAmount,
                                traditionalContribution: dollarsToPercent(
                                  traditionalContributionAmount
                                ),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestion(true)}
                        >
                          Use percentage contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </>
              )}

              {/* ROTH 401k */}
              <Grid item xs={12} mt={2}>
                <Typography variant="h5">Roth 401k Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'rothContribution',
                  label: 'Do you contribute to the Roth 401k?',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.rothContribution,
                  onChange: updateIntakeStateAndSubmit((rothContribution) =>
                    updateIntakeStateAtKey({ rothContribution })
                  ),
                  options: selectData.yesNo,
                })}
              </Grid>

              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'rothBalance',
                  label: 'Current Roth 401k balance',
                  placeholder: '$250,000.00',
                  inputType: 'currencyFloat',
                  value: localForm.rothBalance,
                  onChange: (e) => handleChange('rothBalance')(e),
                  onBlur: updateIntakeStateAndSubmit((rothBalance) =>
                    updateIntakeStateAtKey({ rothBalance })
                  ),
                })}
              </Grid>

              {intakeState?.rothContribution && (
                <>
                  {percentDollarsQuestionRoth ? (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'rothContribution',
                          label: 'What percentage do you contribute?',
                          placeholder: 'Ex. 5.0%',
                          inputType: 'percentage',
                          value: localForm.rothContributionAmount,
                          onChange: (e) => {
                            handleChange('rothContribution')(e)
                            handleChange('rothContributionAmount')(
                              percentToDollars(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (rothContribution) =>
                              updateIntakeStateAtKey({
                                rothContribution,
                                rothContributionAmount:
                                  percentToDollars(rothContribution),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestionRoth(false)}
                        >
                          Use amount contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          autoFocus: false,
                          id: 'rothContributionAmount',
                          label:
                            'What amount do you contribute per pay period?',
                          placeholder: '$135.00',
                          inputType: 'currencyFloat',
                          value: localForm.rothContributionAmount,
                          onChange: (e) => {
                            handleChange('rothContributionAmount')(e)
                            handleChange('rothContribution')(
                              dollarsToPercent(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (rothContributionAmount) =>
                              updateIntakeStateAtKey({
                                rothContributionAmount,
                                rothContribution: dollarsToPercent(
                                  rothContributionAmount
                                ),
                              })
                          ),
                        })}
                      </Grid>
                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setPercentDollarsQuestionRoth(true)}
                        >
                          Use percentage contributed per pay period instead
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Contributions401k
